import type { DataProviderCachePolicy } from '@ragu-components/ord-providers';

export const ingordCachePolicy: DataProviderCachePolicy = {
  // Filled by the backend on its own, so these lists are refetched on every read
  liveResources: ['tasks', 'schedules', 'call_sessions', 'queue_call_sessions'],
  // A task record carries its live run state
  uncachedGetOneResources: ['tasks'],
};
